import HomePage from '../views/home';
import User from '../views/user';
import Order from '../views/order';
import Record from '../views/record';
import Member from '../views/member';
import Accounting from '../views/accounting';
import Admin from '../views/admin';

import HomeIcon from '@material-ui/icons/Home';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ListIcon from '@material-ui/icons/List';
import AddIcon from '@material-ui/icons/Add';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import StorageIcon from '@material-ui/icons/Storage';
import PersonIcon from '@material-ui/icons/Person';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import PermDataSettingIcon from '@material-ui/icons/PermDataSetting';
import AdminPanelSettingsIcon from '@material-ui/icons/AdminPanelSettings';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import PersonAddAlt1Icon from '@material-ui/icons/PersonAddAlt1';
import HistoryIcon from '@material-ui/icons/History';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import Contact from '../views/contact';

import { MODE } from '../utils/mode';

const routeConfigs = [
  {
    name: 'home',
    path: '/',
    isMenuItem: true,
    icon: HomeIcon,
    component: HomePage,
    exact: true,
    meta: { title: '首頁' },
  },
  {
    name: 'login',
    path: '/login',
    component: User.LoginPage,
    meta: {
      title: '登入',
      hideMenu: true,
      authFree: true,
    },
  },
  {
    name: 'register',
    path: '/register',
    component: User.RegisterPage,
    meta: {
      title: '註冊',
      hideMenu: true,
      authFree: true,
    },
  },
  {
    name: 'forgotPassword',
    path: '/forgot-password',
    component: User.ForgotPasswordPage,
    meta: {
      title: '忘記密碼',
      hideMenu: true,
      authFree: true,
    },
  },
  {
    name: 'resetPassword',
    path: '/reset-password',
    component: User.ResetPasswordPage,
    meta: {
      title: '重設密碼',
      hideMenu: true,
      authFree: true,
    },
  },
  {
    name: 'privacyPolicy',
    path: '/privacy-policy',
    component: User.PrivacyPolicyPage,
    meta: {
      title: '隱私權條款',
      hideMenu: true,
      authFree: true,
    },
  },
  {
    name: 'order',
    path: '/order',
    isMenuItem: true,
    nodeOnly: true,
    icon: ListAltIcon,
    component: Order.MainOrderPage,
    meta: {
      title: '訂單管理',
    },
    children: [
      {
        name: 'orderList',
        path: '/list',
        isMenuItem: true,
        isAdminOnly: true,
        icon: ListIcon,
        component: Order.OrderListPage,
        meta: {
          title: '訂單列表',
        },
      },
      {
        name: 'createOrder',
        path: `/${MODE.NEW}/:memberID?`,
        icon: AddIcon,
        component: Order.OrderCreatePage,
        meta: {
          title: '訂單建立',
        },
      },
      {
        name: 'createOrder',
        path: `/${MODE.NEW}`,
        isMenuItem: true,
        isNormalOnly: true,
        icon: AddIcon,
        component: Order.OrderCreatePage,
        meta: {
          title: '訂單建立',
        },
      },
      {
        name: 'createOrderBatch',
        path: '/new-batch',
        isMenuItem: true,
        icon: PlaylistAddIcon,
        component: Order.OrderCreateBatchPage,
        meta: {
          title: '批次訂單建立',
        },
      },
    ],
  },
  {
    name: 'record',
    path: '/record',
    isMenuItem: true,
    icon: HistoryIcon,
    nodeOnly: true,
    component: Record.MainRecordPage,
    meta: {
      title: '案件紀錄',
    },
    children: [
      {
        name: 'recordList',
        path: '/list',
        isMenuItem: true,
        icon: StorageIcon,
        component: Record.RecordListPage,
        meta: {
          title: '案件記錄列表',
        },
      },
      {
        name: 'recordEdit',
        path: `/${MODE.EDIT}/:orderID`,
        isAdminOnly: true,
        component: Record.RecordEditPage,
        meta: {
          title: '編輯案件',
        },
      },
      {
        name: 'recordStatus',
        path: '/status/:orderID',
        component: Record.RecordStatusPage,
        meta: {
          title: '貨況查詢',
        },
      },
      {
        name: 'recordComment',
        path: '/comment/:mode/:orderID',
        component: Record.RecordCommentPage,
        meta: {
          title: '評價訂單',
        },
      },
    ],
  },
  {
    name: 'member',
    path: '/member',
    isMenuItem: true,
    nodeOnly: true,
    icon: PersonIcon,
    component: Member.MainMemberPage,
    meta: {
      title: '會員',
    },
    children: [
      {
        name: 'memberPreorderDetail',
        path: '/preorder/:memberID?',
        component: Member.PreorderRecordPage,
        meta: {
          title: '預購明細',
        },
      },
      {
        name: 'specialSubAccountList',
        path: '/special-sub-account/list',
        component: Member.SpecialSubAccountListPage,
        meta: {
          title: '特殊分帳設定列表',
        },
      },
      {
        name: 'specialSubAccountDetail',
        path: '/special-sub-account/:mode/:dataId?',
        component: Member.SpecialSubAccountDetailPage,
        meta: {
          title: '特殊分帳設定明細',
        },
      },
      {
        name: 'memberList',
        path: '/list',
        isMenuItem: true,
        isAdminOnly: true,
        icon: ListIcon,
        component: Member.MemberListPage,
        meta: {
          title: '會員列表',
        },
      },
      {
        name: 'memberDetail',
        path: '/:mode?/:memberID?',
        component: Member.MemberDetailPage,
        meta: {
          title: '會員資料',
        },
      },
      {
        name: 'createMember',
        path: `/${MODE.NEW}`,
        isMenuItem: true,
        isAdminOnly: true,
        icon: PersonAddAlt1Icon,
        component: Member.MemberDetailPage,
        meta: {
          title: '新增會員',
        },
      },
      {
        menuLabel: '會員資料',
        name: 'memberDetailNav',
        path: `/${MODE.VIEW}`,
        isMenuItem: true,
        isNormalOnly: true,
        icon: AccountBoxIcon,
        meta: {
          title: '會員資料',
        },
      },
      {
        menuLabel: '特殊分帳設定',
        name: 'specialSubAccountNav',
        path: '/special-sub-account/list',
        isMenuItem: true,
        isNormalOnly: true,
        icon: SettingsApplicationsIcon,
      },
    ],
  },
  {
    name: 'contact',
    path: '/contact',
    component: Contact.MainContactPage,
    nodeOnly: true,
    meta: {
      title: '常用聯絡人',
    },
    children: [
      {
        name: 'contactList',
        path: '/list/:memberID?',
        component: Contact.ContactListPage,
        meta: {
          title: '常用聯絡人',
        },
      },
      {
        name: 'contactDetail',
        path: '/:mode/:contactID?',
        component: Contact.ContactDetailPage,
        meta: {
          title: '聯絡人',
        },
      },
    ],
  },
  {
    name: 'accounting',
    path: '/accounting',
    isAdminOnly: true,
    isMenuItem: true,
    nodeOnly: true,
    icon: AccountBalanceIcon,
    component: Accounting.MainAccountingPage,
    meta: {
      title: '會計系統',
    },
    children: [
      {
        name: 'feeMonthly',
        path: '/fee-monthly',
        isMenuItem: true,
        icon: CalendarTodayIcon,
        component: Accounting.FeeMonthlyPage,
        meta: {
          title: '月結手續費',
        },
      },
      {
        name: 'feeSettingDetail',
        path: '/fee-setting/detail/:activityID?',
        isMenuItem: false,
        icon: PermDataSettingIcon,
        component: Accounting.FeeSettingDetailPage,
        meta: {
          title: '手續費設定-編輯',
        },
      },
      {
        name: 'feeSettingNew',
        path: '/fee-setting/new',
        isMenuItem: false,
        icon: PermDataSettingIcon,
        component: Accounting.FeeSettingDetailPage,
        meta: {
          title: '手續費設定-新增',
        },
      },
      {
        name: 'feeSetting',
        path: '/fee-setting',
        isMenuItem: true,
        icon: PermDataSettingIcon,
        component: Accounting.FeeSettingPage,
        meta: {
          title: '設定手續費',
        },
      },
    ],
  },
  {
    name: 'admin',
    path: '/admin',
    isMenuItem: true,
    isAdminOnly: true,
    nodeOnly: true,
    icon: AdminPanelSettingsIcon,
    component: Admin.MainAdminPage,
    meta: {
      title: '後台設定',
    },
    children: [
      {
        name: 'adminHomepageConfig',
        path: '/homepage',
        isMenuItem: true,
        isAdminOnly: true,
        icon: ViewCarouselIcon,
        component: Admin.HomepageConfigPage,
        meta: {
          title: '首頁蓋板',
        },
      },
      {
        name: 'adminNewsConfig',
        path: '/news',
        isMenuItem: true,
        isAdminOnly: true,
        icon: AnnouncementIcon,
        component: Admin.NewsConfigPage,
        meta: {
          title: '最新消息',
        },
      },
    ],
  },
];

export default routeConfigs;
